import React, { ReactElement, useMemo } from "react";
import { useRouteLoaderData } from "react-router-dom";

import { Link } from "@sabre/spark-react-core";

import { theme } from "../../styles/theme";
import { copyRightStyles, footerTextStyles } from "./FooterAIQ.styles";

import { getFooterText } from "@utils/LayoutHelpers";
import { RootLoaderData } from "@utils/Types";

const FooterDivider = (): ReactElement => (
  <span
    className="spark-inline-block"
    style={{
      height: 24,
      width: 1,
      backgroundColor: theme.palette.gray[40],
      margin: "0 16px",
    }}
  />
);

const FooterAIQ = (): ReactElement => {
  const { systemInfo } = useRouteLoaderData("root") as RootLoaderData;
  let buildTimeStamp;
  try {
    buildTimeStamp = import.meta.env.VITE_CURRENT_BUILD_START_TIME
      ? new Date(import.meta.env.VITE_CURRENT_BUILD_START_TIME)
      : new Date(0);
  } catch {
    buildTimeStamp = new Date(0);
  }
  const artifactVersion = import.meta.env.VITE_CURRENT_BUILD_VERSION
    ? import.meta.env.VITE_CURRENT_BUILD_VERSION
    : "local-b001-AAAAaaaa";
  const buildUrl = import.meta.env.VITE_CURRENT_BUILD_URL ? import.meta.env.VITE_CURRENT_BUILD_URL : "#";

  const footerText = useMemo(() => getFooterText(), []);

  return (
    <footer>
      <div className="container-fluid footer-aiq-container">
        <div className="footer-aiq">
          <div className={footerTextStyles}>
            <p className={copyRightStyles}>{footerText}</p>
          </div>
          <div className="spark-flex spark-align-items-center">
            <div>
              {systemInfo.env} - {systemInfo.envDescription}
            </div>
            {systemInfo.showSensitiveInfo && (
              <>
                <FooterDivider />
                <Link underline target="_blank" href={buildUrl} rel="noreferrer" title={buildTimeStamp.toUTCString()}>
                  {artifactVersion}
                </Link>
              </>
            )}
            {!systemInfo.showSensitiveInfo && (
              <>
                <FooterDivider />
                <p>{artifactVersion}</p>
              </>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterAIQ;
